import React, { ChangeEvent, useCallback, useContext, useEffect, useState } from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import UserTypesEnum from "../../../models/UserTypesEnum";
import ReportTypeEnum from "../../../models/ReportTypeEnum";
import ReportPeriodTypeEnum from "../../../models/ReportPeriodTypeEnum";
import ReportPeriodType from "../../../models/ReportPeriodTypeEnum";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwDateRange from "../../shared/OwDateRange/OwDateRange";
import { Moment } from "moment-timezone";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import ICreateReportDTO from "../../../models/DTO/ICreateReportDTO";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnCreateReportDTO from "../../../models/DTO/IOnCreateReportDTO";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IProcessed_Report from "../../../models/IProcessed_Report";
import Typeahead from "../../shared/Typeahead/Typeahead";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import ICatalog from "../../../models/ICatalog";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IGetItemInOrdersReportDTO from "../../../models/DTO/IGetItemInOrdersReportDTO";
import IOnGetItemInOrdersReportDTO from "../../../models/DTO/IOnGetItemInOrdersReportDTO";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OrderEntryService from "../../../services/OrderEntryService";
import { Socket } from "socket.io-client";
import ICustom_Report from "../../../models/ICustom_Report";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import ICategoriesTypeaheadGetCategoriesDTO from "../../../models/DTO/ICategoriesTypeaheadGetCategoriesDTO";
import ICategory from "../../../models/ICategory";
import ICategoriesOnTypeaheadGetCategoriesDTO from "../../../models/DTO/ICategoriesOnTypeaheadGetCategoriesDTO";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { TypeaheadFn } from "@components/shared/TypeaheadFn/TypeaheadFn";
import OrdersDetailReportQbo from "./SpecificReportOptions/OrdersDetailReportQbo";
import UIService from "@services/UIService";
import CategoryService from "../../../services/CategoryService";

type Props = {
    close: (refresh?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    processedReport?: IProcessed_Report;
    setActivityIndicator: (activityIndicator: boolean) => void;
    customReports: ICustom_Report[];
};

interface IReportOption {
    value: ReportTypeEnum;
    title: string;
    guid?: string;
}

export const CreateReportSidebar: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const getReportOptions = () => {
        const _reportOptions: IReportOption[] = [
            // { value: ReportTypeEnum.SALES_BY_USER, title: "Inventory Report" },
        ];

        let vendorNotesReportTitle = "vendor_notes_review";

        if (supplierModel.vendor_name_override) {
            vendorNotesReportTitle = vendorNotesReportTitle.replace(/vendor/, supplierModel.vendor_name_override);
        }

        switch (userModel.supplierUserToken?.User_Type?.id) {
            case UserTypesEnum.ADMIN:
            case UserTypesEnum.ORDER_MGMT:
            case UserTypesEnum.INVENTORY_MGMT: {
                _reportOptions.push(
                    { value: ReportTypeEnum.ORDERS_DETAIL_REPORT, title: "orders_detail_report" },
                    { value: ReportTypeEnum.SALES_BY_USER, title: "sales_volume_by_user" },
                    { value: ReportTypeEnum.SALES_BY_PRODUCT_BY_CUSTOMER, title: "customer_product_sales" },
                    { value: ReportTypeEnum.PRODUCT_CUSTOMER_SALES, title: "product_customer_sales" },
                    { value: ReportTypeEnum.TOTAL_LOGINS_REPORT, title: "total_logins_report" },
                    { value: ReportTypeEnum.ORDERS_CREATED, title: "orders_created_report" },
                    { value: ReportTypeEnum.ORDERS_SUBMITTED, title: "orders_submitted_report" },
                    { value: ReportTypeEnum.ITEM_IN_ORDERS_REPORT, title: "item_in_orders_report" },
                    { value: ReportTypeEnum.OPEN_ORDER_REPORT, title: "open_orders_report" },
                    { value: ReportTypeEnum.INVENTORY_STOCKOUT_REPORT, title: "inventory_stockout_report" },
                    { value: ReportTypeEnum.INVENTORY_COST_BREAKDOWN_REPORT, title: "inventory_cost_breakdown_report" },
                    { value: ReportTypeEnum.OPEN_ORDERS_WITH_PARTIAL_SHIPMENTS, title: "open_orders_with_partial_shipments" }
                );

                if (supplierModel.has_backorders) {
                    _reportOptions.push({ value: ReportTypeEnum.BACKORDER_REPORT, title: "backorder_report" });
                }

                break;
            }
        }

        // Admin only reports.
        switch (userModel.supplierUserToken?.User_Type?.id) {
            case UserTypesEnum.ADMIN:
                _reportOptions.push({ value: ReportTypeEnum.ACCOUNT_RESALE_TAX_DOC_REPORT, title: "account_resale_tax_document_report" });
                break;
        }

        if (supplierModel) {
            if (supplierModel.has_analytics) {
                switch (userModel.supplierUserToken?.User_Type?.id) {
                    case UserTypesEnum.ADMIN:
                    case UserTypesEnum.ORDER_MGMT:
                    case UserTypesEnum.INVENTORY_MGMT:
                        _reportOptions.push({ value: ReportTypeEnum.PRODUCT_SEARCHES_BY_CUSTOMER, title: "product_searches_by_customer" });
                        break;
                }
            }

            if (supplierModel.has_serials) {
                switch (userModel.supplierUserToken?.User_Type?.id) {
                    case UserTypesEnum.ADMIN:
                    case UserTypesEnum.ORDER_MGMT:
                    case UserTypesEnum.INVENTORY_MGMT:
                        _reportOptions.push({ value: ReportTypeEnum.SERIALS_IN_ORDERS_REPORT, title: "serials_in_orders_report" });
                        break;
                }
            }

            if (supplierModel.has_commissions) {
                _reportOptions.push({ value: ReportTypeEnum.COMMISSION_REPORT, title: "commission_report" });
            }

            if (supplierModel.has_rebates) {
                _reportOptions.push({ value: ReportTypeEnum.VOLUME_REBATE_REPORT, title: "volume_rebate_report" });
            }

            if (supplierModel.has_coop_advertisement) {
                _reportOptions.push({ value: ReportTypeEnum.COOP_REPORT, title: "coop_advertisement_report" });
            }

            if (supplierModel.has_spiff) {
                _reportOptions.push({ value: ReportTypeEnum.SPIFF_REPORT, title: "spiff_report" });
            }

            if (userModel.userType?.id === UserTypesEnum.ADMIN) {
                _reportOptions.push({ value: ReportTypeEnum.INVENTORY_STOCK_LEVELS_REPORT, title: "inventory_stock_levels_report" });
                _reportOptions.push({
                    value: ReportTypeEnum.INVENTORY_STOCK_HISTORY_TRANSACTION_REPORT,
                    title: "inventory_stock_history_transaction_report",
                });
                _reportOptions.push({ value: ReportTypeEnum.ACCOUNTS_BY_DATE_REPORT, title: "accounts_by_date_report" });
                _reportOptions.push({ value: ReportTypeEnum.SINGLE_CATEGORY_QTY_SALES_REPORT, title: "single_category_qty_sales_report" });
            }

            if (props.customReports.length) {
                for (const customReport of props.customReports) {
                    _reportOptions.push({ value: ReportTypeEnum.CUSTOM, title: customReport.name, guid: customReport.guid });
                }
            }
        }

        _reportOptions.push({ value: ReportTypeEnum.CUSTOMER_NOTES_REVIEW, title: vendorNotesReportTitle });
        _reportOptions.push({ value: ReportTypeEnum.ACTIVITY_REPORT, title: "activity_report" });
        _reportOptions.push({ value: ReportTypeEnum.INACTIVE_ACCOUNT_REPORT, title: "inactive_account_report" });
        _reportOptions.push({ value: ReportTypeEnum.CATEGORY_QTY_SALES_REPORT, title: "all_category_qty_sales_report" });

        return _reportOptions.sort((a, b) => (a.title > b.title ? 1 : -1));
    };

    const getPeriodTypeOptions = () => {
        return [
            { value: ReportPeriodTypeEnum.CURRENT_MONTH, title: "Current Month" },
            { value: ReportPeriodTypeEnum.LAST_MONTH, title: "Last Month" },
            { value: ReportPeriodTypeEnum.CURRENT_QUARTER, title: "Current Quarter" },
            { value: ReportPeriodTypeEnum.LAST_QUARTER, title: "Last Quarter" },
            { value: ReportPeriodTypeEnum.CURRENT_YEAR, title: "Current Year" },
            { value: ReportPeriodTypeEnum.LAST_YEAR, title: "Last Year" },
            { value: ReportPeriodTypeEnum.CUSTOM_RANGE, title: "Custom Range" },
        ];
    };

    const [reportOptions, setReportOptions] = useState<{ value: ReportTypeEnum; title: string }[]>(getReportOptions());
    const [periodTypeOptions, setPeriodTypeOptions] = useState<{ value: ReportPeriodTypeEnum; title: string }[]>(getPeriodTypeOptions());
    const [currentReport, setCurrentReport] = useState<ReportTypeEnum>();
    const [showPeriodType, setShowPeriodType] = useState(false);
    const [periodType, setPeriodType] = useState<ReportPeriodType>();
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const [showSampleSales, setShowSampleSales] = useState(false);
    const [sampleSalesFlag, setSampleSalesFlag] = useState(false);
    const [showCommissionUsersOnly, setShowCommissionUsersOnly] = useState(false);
    const [commissionUsersOnlyFlag, setCommissionUsersOnlyFlag] = useState(false);
    const [showCatalogSelection, setShowCatalogSelection] = useState(false);
    const [showCategorySelection, setShowCategorySelection] = useState(false);
    const [showOrderStatusSelection, setShowOrderStatusSelection] = useState(false);
    const [showIncludeCancelledOrdersOption, setShowIncludeCancelledOrdersOption] = useState(false);
    const [includeCancelledOrders, setIncludeCancelledOrders] = useState(false);
    const [hideMainSearchBtn, setHideMainSearchBtn] = useState(false);
    const [hideCatalogItemSelection, setHideCatalogItemSelection] = useState(false);
    const [showPricingSelection, setShowPricingSelection] = useState(false);
    const [includePricing, setIncludePricing] = useState(false);
    const [reqOptionsSet, setReqOptionsSet] = useState(false);
    const [selectedCustomReport, setSelectedCustomReport] = useState<ICustom_Report | undefined>();

    const [active, setActive] = useState(false);
    const [title, setTitle] = useState("");
    const supplierOrderSteps = OrderEntryService.getOrderSteps(supplierModel, OrderStatesEnum.PRELIMINARY);

    const [stepSelected, setStepSelected] = useState<{ [key: number]: boolean }>({});
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [selectedCatalog, setSelectedCatalog] = useState<string | undefined>(undefined);
    const [foundCatalogItems, setFoundCatalogItems] = useState<ICatalog_Item[]>();
    const [selectedCatalogItem, setSelectedCatalogItem] = useState<ICatalog_Item | undefined>();
    const [reportData, setReportData] = useState<IOnGetItemInOrdersReportDTO>();
    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);
    const [clearCategoryTypeahead, setClearCategoryTypeahead] = useState<boolean>(false);
    const [foundCategories, setFoundCategories] = useState<ICategory[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<ICategory | undefined>();
    const [includeSubCategories, setIncludeSubCategories] = useState(true);
    const [quotesOnly, setQuotesOnly] = useState(false);
    const [showQboOptions, setShowQboOptions] = useState(false);
    const [quickbooksOnline, setQuickbooksOnline] = useState<{ hasInvoice?: boolean } | undefined>(undefined);

    // Order Category Selection for SALES_BY_PRODUCT_BY_CUSTOMER report
    const [showOrderCategorySelection, setShowOrderCategorySelection] = useState(false);
    const [orderCategories, setOrderCategories] = useState<ICategory[]>([]);
    const [selectedOrderCategory, setSelectedOrderCategory] = useState<ICategory | undefined>();

    // Product Customer Sales Report - Multiple product selection
    const [productSelectionMode, setProductSelectionMode] = useState<"products" | "category" | "all-items">("products");
    const [selectedProducts, setSelectedProducts] = useState<ICatalog_Item[]>([]);
    const [selectAllProductsInCategory, setSelectAllProductsInCategory] = useState(false);

    useEffect(() => {
        if (currentReport && title.length) {
            setReqOptionsSet(true);
        }
    });

    const onCreateReport = (data: IOnCreateReportDTO) => {
        const notification: INotification = {
            message: "successfully_queued_report",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        props.close(true);
    };

    const onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        setFoundCatalogItems(data.catalog_items);
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const onItemInOrdersReport = (data: IOnGetItemInOrdersReportDTO) => {
        setReportData(data);
        props.setActivityIndicator(false);
    };

    const onTypeaheadGetCategories = (data: ICategoriesOnTypeaheadGetCategoriesDTO) => {
        setFoundCategories(data.categories);
        props.setActivityIndicator(false);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.ReportOnCreateReport, fn: onCreateReport },
        { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: onTypeaheadCatalogItem },
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.ReportOnItemInOrdersReport, fn: onItemInOrdersReport },
        { endpoint: EndpointsEnum.CategoriesOnTypeaheadGetCategories, fn: onTypeaheadGetCategories },
    ];

    useEffect(() => {
        for (const socket of sockets) {
            props.socket.on(socket.endpoint, socket.fn);
        }

        const stepSelectedInit: { [key: string]: boolean } = {};

        for (const step of supplierOrderSteps) {
            if (
                step.order_state_id === OrderStatesEnum.PRELIMINARY ||
                step.order_state_id === OrderStatesEnum.SHIPPED ||
                step.order_state_id === OrderStatesEnum.DELIVERED ||
                step.order_state_id === OrderStatesEnum.PICKED_UP
            ) {
                stepSelectedInit[step.order_state_id] = false;
            } else {
                stepSelectedInit[step.order_state_id] = true;
            }
        }

        setStepSelected(stepSelectedInit);

        getCatalogs();

        return () => {
            for (const socket of sockets) {
                props.socket.removeListener(socket.endpoint, socket.fn);
            }
        };
    }, []);

    const createReport = () => {
        if (currentReport) {
            // tslint:disable-next-line:variable-name
            const report_options: any = {
                startDate,
                endDate,
                periodType,
                reportType: currentReport,
            };

            if (selectedCatalogItem) {
                report_options.itemGuid = selectedCatalogItem.guid;
                report_options.catalogItemGuid = selectedCatalogItem.guid;
                report_options.itemName = selectedCatalogItem.name;
            }

            if (showOrderStatusSelection) {
                const orderStatus: number[] = [];

                for (const key of Object.keys(stepSelected)) {
                    if (stepSelected[Number(key)]) {
                        orderStatus.push(Number(key));
                    }
                }

                report_options.orderStatus = orderStatus;
            }

            if (selectedCatalog) {
                report_options.catalogGuid = selectedCatalog;
            }

            if (selectedCategory) {
                report_options.categoryGuid = selectedCategory.guid;
            }

            if (includePricing) {
                report_options.includePricing = true;
            }

            // Product Customer Sales Report - Add product IDs or category ID
            if (currentReport === ReportTypeEnum.PRODUCT_CUSTOMER_SALES) {
                if (productSelectionMode === "products" && selectedProducts.length > 0) {
                    report_options.productIds = selectedProducts.map((p) => p.id);
                } else if (productSelectionMode === "category" && selectedCategory) {
                    report_options.categoryId = selectedCategory.id;
                    // If "select all products" is checked, send undefined productIds to get all products in category
                    if (selectAllProductsInCategory) {
                        report_options.productIds = undefined;
                    }
                }
                report_options.excludeZeroSales = true;
            }

            // Sales By Product By Customer Report - Add category ID and includeCancelledOrders
            if (currentReport === ReportTypeEnum.SALES_BY_PRODUCT_BY_CUSTOMER) {
                if (selectedOrderCategory) {
                    report_options.categoryId = selectedOrderCategory.id;
                }
                report_options.includeCancelledOrders = includeCancelledOrders;
            }

            // Orders Detail Report - Add category ID
            if (currentReport === ReportTypeEnum.ORDERS_DETAIL_REPORT) {
                if (selectedOrderCategory) {
                    report_options.categoryId = selectedOrderCategory.id;
                }
            }

            if (selectedCustomReport) {
                report_options.custom_report_guid = selectedCustomReport.guid;
            }

            if (currentReport === ReportTypeEnum.SINGLE_CATEGORY_QTY_SALES_REPORT) {
                if (includeSubCategories) {
                    report_options.includeSubCategories = includeSubCategories;
                }
            }

            if (currentReport === ReportTypeEnum.ITEM_IN_ORDERS_REPORT) {
                report_options.quotesOnly = quotesOnly;
            }

            if (quickbooksOnline) {
                report_options.quickbooksOnline = quickbooksOnline;
            }

            const payload: ICreateReportDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                newReport: {
                    report_type: currentReport,
                    title,
                    report_options,
                },
            };

            props.socket.emit(EndpointsEnum.ReportCreateReport, payload);
        }
    };

    useEffect(() => {
        // console.log("selectedCatalog", selectedCatalog);
    }, [selectedCatalog]);

    const toggleStep = (step: IOrder_Progress_State) => {
        const existingStepSelect = {
            ...stepSelected,
        };

        existingStepSelect[step.order_state_id] = !stepSelected[step.order_state_id];

        setStepSelected(existingStepSelect);
    };

    const doCatalogItemLookup = (name: string) => {
        if (selectedCatalog) {
            const payload: ITypeaheadCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                name,
                catalogGuid: selectedCatalog,
                ignoreProductGroups: true,
                limit: 100,
                options: {
                    searchName: true,
                    searchDescription: true,
                    searchSku: true,
                    searchUpc: true,
                },
            };

            props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
        }
    };

    const doCategoryLookup = (name: string) => {
        if (selectedCatalog) {
            const payload: ICategoriesTypeaheadGetCategoriesDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                name,
                catalogGuid: selectedCatalog,
            };

            props.socket.emit(EndpointsEnum.CategoriesTypeaheadGetCategories, payload);

            props.setActivityIndicator(true);
        }
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            callMeta: {
                view: "CreateReportSidebar",
                fn: "getCatalogs",
            },
        };

        props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const fetchOrderCategories = useCallback(async () => {
        try {
            const categories = await CategoryService.getCategories(
                { isOrderCategory: true, onlyRootCategories: true },
                userModel,
                supplierModel
            );
            setOrderCategories(categories.filter((c) => !c.hide_category));
        } catch (error) {
            console.error("Error fetching order categories", error);
            setOrderCategories([]);
        }
    }, [userModel, supplierModel]);

    const handleCatalogChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        let foundCatalog: ICatalog | undefined;

        for (const catalog of catalogs) {
            if (catalog.guid === value) {
                foundCatalog = catalog;
            }
        }

        if (selectedCatalog !== foundCatalog) {
            setSelectedCatalog(undefined);
            setSelectedCatalogItem(undefined);
            setClearTypeahead(true);
        }

        setSelectedCatalog(foundCatalog ? foundCatalog.guid : undefined);
    };

    const selectCatalogItem = (item: ICatalog_Item) => {
        setSelectedCatalogItem(item);
    };

    const selectCategory = (item: ICategory) => {
        setSelectedCategory(item);
    };

    const clearTypeaheadFn = () => {
        setSelectedCatalogItem(undefined);
        setClearTypeahead(false);
    };

    const clearCategoryTypeaheadFn = () => {
        setSelectedCategory(undefined);
        setClearCategoryTypeahead(false);
    };

    const handleOrderCategoryChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const categoryId = Number(e.target.value);
        const category = orderCategories.find((c) => c.id === categoryId);
        setSelectedOrderCategory(category);
    };

    // Product Customer Sales Report - Multiple product handlers
    const addProductToSelection = (item: ICatalog_Item) => {
        if (selectedProducts.length < 50 && !selectedProducts.find((p) => p.guid === item.guid)) {
            setSelectedProducts([...selectedProducts, item]);
            setSelectedCatalogItem(undefined);
            setClearTypeahead(true);
        }
    };

    const removeProductFromSelection = (productGuid: string) => {
        setSelectedProducts(selectedProducts.filter((p) => p.guid !== productGuid));
    };

    const handleProductSelectionModeChange = (mode: "products" | "category" | "all-items") => {
        if (mode === "category" && selectedProducts.length > 0) {
            if (window.confirm("Switching to category mode will clear your selected products. Continue?")) {
                setSelectedProducts([]);
                setProductSelectionMode(mode);
            }
        } else if (mode === "products" && selectedCategory) {
            if (window.confirm("Switching to products mode will clear your selected category. Continue?")) {
                setSelectedCategory(undefined);
                setClearCategoryTypeahead(true);
                setProductSelectionMode(mode);
            }
        } else {
            setProductSelectionMode(mode);
        }
    };

    const doSearch = () => {
        if (selectedCatalogItem) {
            const orderStatus: number[] = [];

            for (const key of Object.keys(stepSelected)) {
                if (stepSelected[Number(key)]) {
                    orderStatus.push(Number(key));
                }
            }

            const payload: IGetItemInOrdersReportDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                reportType: ReportTypeEnum.ITEM_IN_ORDERS_REPORT,
                itemGuid: selectedCatalogItem.guid,
                orderStatus,
                periodType: ReportPeriodType.CUSTOM_RANGE,
                quotesOnly,
            };

            props.socket.emit(EndpointsEnum.ReportItemInOrdersReport, payload);

            props.setActivityIndicator(true);
        }
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;

        switch (name) {
            case "sampleSalesFlag":
                setSampleSalesFlag(value);
                break;

            case "commissionUsersOnlyFlag":
                setCommissionUsersOnlyFlag(value);
                break;

            case "title":
                setTitle(value);
                break;

            case "includeCancelledOrdersFlag":
                setIncludeCancelledOrders(value);
                break;

            case "includeSubCategories":
                setIncludeSubCategories(value);
                break;

            case "quotesOnly":
                setQuotesOnly(value);
                break;

            case "includePricing":
                setIncludePricing(value);
                break;
        }
    };

    const handlePeriodTypeChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        setPeriodType(value);
    };

    const setDate = (type: string, date: Moment | null) => {
        const formatStr = "YYYY-MM-DD";

        // if (type === 'endDate') {
        //   formatStr = 'YYYY-MM-DD';
        // }

        if (date) {
            if (type === "startDate") {
                setStartDate(date.format(formatStr));
            } else {
                setEndDate(date.format(formatStr));
            }
        }

        // let state: any = {
        //     [type]: date ? date.format(formatStr) : date,
        // };
        //
        // this.setState(state);
    };

    const handleReportChange = (reportOption: IReportOption) => {
        const name = reportOption.title;
        const value = reportOption.value;
        const guid = reportOption.guid;

        let customReportSelected: ICustom_Report | undefined;

        if (guid) {
            for (const customReport of props.customReports) {
                if (customReport.guid === guid) {
                    customReportSelected = customReport;
                }
            }
        }

        let _showPeriodType = false;
        let _showSampleSales = false;
        let _hideMainSearchBtn = false;
        let _showOrderStatusSelection = false;
        let _showCommissionUsersOnly = false;
        let _showCatalogSelection = false;
        let _showIncludeCancelledOrdersOption = false;
        let _hideCatalogItemSelection = false;
        let _showCategorySelection = false;
        let _showQboOptions = false;
        let _showPricingSelection = false;
        let _showOrderCategorySelection = false;

        switch (value) {
            case ReportTypeEnum.SALES_BY_USER:
                _showCommissionUsersOnly = true;
                _showSampleSales = true;
                _showPeriodType = true;
                break;
            case ReportTypeEnum.SAMPLE_SALES_BY_USER:
            case ReportTypeEnum.ITEM_SALES_REPORT:
                _showSampleSales = true;
                _showPeriodType = true;
                break;
            case ReportTypeEnum.COMMISSION_REPORT:
            case ReportTypeEnum.COMMISSION_TIER_REPORT:
            case ReportTypeEnum.VOLUME_REBATE_REPORT:
            case ReportTypeEnum.COOP_REPORT:
            case ReportTypeEnum.PRODUCT_SEARCHES_BY_CUSTOMER:
            case ReportTypeEnum.ORDERS_CREATED:
            case ReportTypeEnum.ORDERS_SUBMITTED:
            case ReportTypeEnum.ACTIVITY_REPORT:
            case ReportTypeEnum.INACTIVE_ACCOUNT_REPORT:
            case ReportTypeEnum.ACCOUNTS_BY_DATE_REPORT:
                _showPeriodType = true;
                break;

            case ReportTypeEnum.ORDERS_DETAIL_REPORT:
                _showPeriodType = true;
                _showOrderStatusSelection = true;
                _showQboOptions = true;
                _showPricingSelection = true;
                _showOrderCategorySelection = true;
                break;

            case ReportTypeEnum.TOTAL_LOGINS_REPORT:
                break;

            case ReportTypeEnum.SALES_BY_PRODUCT_BY_CUSTOMER:
                _showPeriodType = true;
                _showIncludeCancelledOrdersOption = true;
                _showOrderCategorySelection = true;
                break;

            case ReportTypeEnum.PRODUCT_CUSTOMER_SALES:
                _showPeriodType = true;
                _showIncludeCancelledOrdersOption = true;
                _showCatalogSelection = true;
                _showCategorySelection = true;
                break;

            case ReportTypeEnum.BACKORDER_REPORT:
                _showOrderStatusSelection = true;
                _hideMainSearchBtn = false;
                break;

            case ReportTypeEnum.ITEM_IN_ORDERS_REPORT:
                _showPeriodType = true;
                _showOrderStatusSelection = true;
                _hideMainSearchBtn = true;
                _showCatalogSelection = true;
                break;

            case ReportTypeEnum.SERIALS_IN_ORDERS_REPORT:
                _showPeriodType = true;
                _showOrderStatusSelection = false;
                _hideMainSearchBtn = true;
                _showCatalogSelection = true;
                break;

            case ReportTypeEnum.SPIFF_REPORT:
                _showPeriodType = true;
                _hideMainSearchBtn = true;
                break;

            case ReportTypeEnum.INVENTORY_STOCK_LEVELS_REPORT:
                _showCatalogSelection = true;
                break;

            case ReportTypeEnum.INVENTORY_STOCK_HISTORY_TRANSACTION_REPORT:
                _showCatalogSelection = true;
                _showPeriodType = true;
                break;

            case ReportTypeEnum.CATEGORY_QTY_SALES_REPORT:
                _showPeriodType = true;
                _showCatalogSelection = true;
                _hideCatalogItemSelection = true;
                break;

            case ReportTypeEnum.SINGLE_CATEGORY_QTY_SALES_REPORT:
                _showPeriodType = true;
                _showCatalogSelection = true;
                _hideCatalogItemSelection = true;
                _showCategorySelection = true;
                break;

            case ReportTypeEnum.INVENTORY_COST_BREAKDOWN_REPORT:
                _showCatalogSelection = true;
                _hideCatalogItemSelection = true;
                break;

            case ReportTypeEnum.CUSTOM:
                {
                    if (customReportSelected) {
                        _showPeriodType = customReportSelected.config.create.showPeriodType || true;
                        _showCatalogSelection = customReportSelected.config.create.showCatalogSelection || false;
                        _showOrderStatusSelection = customReportSelected.config.create.showOrderStatusSelection || false;
                    }
                }
                break;
        }

        setCurrentReport(value);
        setShowPeriodType(_showPeriodType);
        setShowSampleSales(_showSampleSales);
        setHideMainSearchBtn(_hideMainSearchBtn);
        setShowOrderStatusSelection(_showOrderStatusSelection);
        setShowCommissionUsersOnly(_showCommissionUsersOnly);
        setShowCatalogSelection(_showCatalogSelection);
        setShowIncludeCancelledOrdersOption(_showIncludeCancelledOrdersOption);
        setSelectedCustomReport(customReportSelected);
        setHideCatalogItemSelection(_hideCatalogItemSelection);
        setShowCategorySelection(_showCategorySelection);
        setShowQboOptions(_showQboOptions);
        setShowPricingSelection(_showPricingSelection);
        setShowOrderCategorySelection(_showOrderCategorySelection);
        setSelectedOrderCategory(undefined);

        if (_showOrderCategorySelection && supplierModel.has_order_categories) {
            fetchOrderCategories();
        }
    };

    return (
        <div className={"CreateReportSidebar p-3"}>
            <div className={"d-flex flex-column"}>
                <div className={"ms-auto"}>
                    <OwButton centerIconClass={"fas fa-times"} fn={() => props.close()} className={"btn-danger ms-auto"} />
                </div>

                <OwTitle title={"create_report"} />
            </div>

            <div>
                <div className={"d-flex row align-items-center mb-3 w-30r"}>
                    <div className={"col-12 mb-3"}>
                        <OwLabel title={"report"} showIsReqAsterik={true} />
                        <OwSelectOption
                            options={reportOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={handleReportChange}
                            name={"currentReport"}
                            showBlankFirst={true}
                            translateTitle={true}
                            emitObject={true}
                        />
                    </div>
                    <div className={"col-12 mb-3"}>
                        <OwLabel title={"report_title"} showIsReqAsterik={true} />
                        <OwFnInput fn={handleChange} name={"title"} value={title} isRequired={true} />
                    </div>
                    <div className={"mb-3 col-12 " + (showPeriodType ? "" : "d-none")}>
                        <div className="">
                            <OwLabel title={"range_option"} showIsReqAsterik={true} />
                            <OwSelectOption
                                options={periodTypeOptions}
                                valueProp={"value"}
                                titleProp={"title"}
                                fn={handlePeriodTypeChange}
                                name={"date_range"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                    <div className={"mb-3 col-12 " + (periodType === ReportPeriodType.CUSTOM_RANGE ? "" : "d-none")}>
                        <OwLabel title={"date_range"} />
                        <OwDateRange
                            startFn={(date: Moment | null) => {
                                setDate("startDate", date);
                            }}
                            endFn={(date: Moment | null) => {
                                setDate("endDate", date);
                            }}
                        />
                    </div>
                    <div className={"mb-3 col-12 " + (showSampleSales ? "" : "d-none")}>
                        <div className={"col-12"}>
                            <OwLabel />
                        </div>
                        <div className={"col-12"}>
                            <OwCheckbox
                                fn={handleChange}
                                name={"sampleSalesFlag"}
                                label={"only_sample_sales"}
                                checked={sampleSalesFlag}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    </div>
                    <div className={"mb-3 col-12 " + (showCommissionUsersOnly ? "" : "d-none")}>
                        <div className={"col-12"}>
                            <OwLabel />
                        </div>
                        <div className={"col-12"}>
                            <OwCheckbox
                                fn={handleChange}
                                name={"commissionUsersOnlyFlag"}
                                label={"only_commission_users"}
                                checked={commissionUsersOnlyFlag}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    </div>

                    {showIncludeCancelledOrdersOption ? (
                        <div className={"mb-3 col-12 "}>
                            <div className={"col-12"}>
                                <OwLabel />
                            </div>
                            <div className={"col-12"}>
                                <OwToggle
                                    fn={handleChange}
                                    name={"includeCancelledOrdersFlag"}
                                    label={"include_cancelled_orders"}
                                    active={includeCancelledOrders}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>
                    ) : null}

                    {showOrderCategorySelection && supplierModel.has_order_categories ? (
                        <div className={"mb-3 col-12"}>
                            <div className={"col-12"}>
                                <OwLabel title={"order_category"} isBold={true} />
                            </div>
                            <div className={"col-12"}>
                                <OwSelectOption
                                    options={orderCategories}
                                    valueProp={"id"}
                                    titleProp={"name"}
                                    fn={handleOrderCategoryChange}
                                    name={"orderCategory"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>
                    ) : null}

                    {showCatalogSelection ? (
                        <div className={"mb-3 col-12"}>
                            <div>
                                <div>
                                    <div>
                                        <OwLabel title={"catalog"} isBold={true} isUnderline={true} showIsReqAsterik={true} />
                                    </div>
                                    <OwSelectOption
                                        name={"catalog"}
                                        fn={handleCatalogChange}
                                        options={catalogs}
                                        selectedOption={selectedCatalog}
                                        selectedOptionProp={""}
                                        titleProp={"name"}
                                        valueProp={"guid"}
                                    />
                                </div>

                                {/* Product Customer Sales Report - Custom UI */}
                                {currentReport === ReportTypeEnum.PRODUCT_CUSTOMER_SALES && selectedCatalog ? (
                                    <div className={"mt-3"}>
                                        <div className={"mb-3"}>
                                            <OwLabel
                                                title={"product_selection_mode"}
                                                isBold={true}
                                                isUnderline={true}
                                                showIsReqAsterik={true}
                                            />
                                            <div className={"d-flex gap-3 mt-2"}>
                                                <div className={"form-check"}>
                                                    <input
                                                        className={"form-check-input"}
                                                        type={"radio"}
                                                        name={"productSelectionMode"}
                                                        id={"mode-all-items"}
                                                        checked={productSelectionMode === "all-items"}
                                                        onChange={() => handleProductSelectionModeChange("all-items")}
                                                    />
                                                    <label className={"form-check-label"} htmlFor={"mode-all-items"}>
                                                        All Items
                                                    </label>
                                                </div>
                                                <div className={"form-check"}>
                                                    <input
                                                        className={"form-check-input"}
                                                        type={"radio"}
                                                        name={"productSelectionMode"}
                                                        id={"mode-products"}
                                                        checked={productSelectionMode === "products"}
                                                        onChange={() => handleProductSelectionModeChange("products")}
                                                    />
                                                    <label className={"form-check-label"} htmlFor={"mode-products"}>
                                                        Specific Products
                                                    </label>
                                                </div>
                                                <div className={"form-check"}>
                                                    <input
                                                        className={"form-check-input"}
                                                        type={"radio"}
                                                        name={"productSelectionMode"}
                                                        id={"mode-category"}
                                                        checked={productSelectionMode === "category"}
                                                        onChange={() => handleProductSelectionModeChange("category")}
                                                    />
                                                    <label className={"form-check-label"} htmlFor={"mode-category"}>
                                                        Category
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {productSelectionMode === "products" && (
                                            <div>
                                                <div className={"mb-2"}>
                                                    <OwLabel
                                                        title={"select_products"}
                                                        isBold={true}
                                                        isUnderline={true}
                                                        showIsReqAsterik={true}
                                                    />
                                                    <div className={"text-muted small"}>{selectedProducts.length} products selected</div>
                                                </div>
                                                <TypeaheadFn
                                                    lookupFn={doCatalogItemLookup}
                                                    availableOptions={foundCatalogItems || []}
                                                    titleProp={"name"}
                                                    selectedOptionFn={addProductToSelection}
                                                    selectedOption={selectedCatalogItem}
                                                    resetTypeahead={clearTypeahead}
                                                    resetTypeaheadCallbackFn={clearTypeaheadFn}
                                                    isScrollable={true}
                                                />
                                                {selectedProducts.length > 0 && (
                                                    <div
                                                        className={"mt-3 p-2 border rounded"}
                                                        style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                        {selectedProducts.map((product) => (
                                                            <div
                                                                key={product.guid}
                                                                className={
                                                                    (UIService.isMainViewLight() ? "bg-light" : "secondary-bg-color") +
                                                                    " d-flex justify-content-between align-items-center mb-2 p-2 rounded"
                                                                }>
                                                                <span>
                                                                    {product.name}
                                                                    <span className={"text-muted ms-2"}>({product.sku})</span>
                                                                </span>
                                                                <button
                                                                    type={"button"}
                                                                    className={"btn btn-sm btn-danger"}
                                                                    onClick={() => removeProductFromSelection(product.guid)}>
                                                                    <i className={"fas fa-times"} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {productSelectionMode === "category" && (
                                            <div>
                                                <div>
                                                    <OwLabel title={"category"} isBold={true} isUnderline={true} showIsReqAsterik={true} />
                                                </div>
                                                <Typeahead
                                                    isSelectableFn={() => true}
                                                    typeaheadApiFn={doCategoryLookup}
                                                    typeaheadItems={foundCategories}
                                                    titleProp={"name"}
                                                    selectedItemTitleProp={"name"}
                                                    selectedItemFn={selectCategory}
                                                    selectedItem={selectedCategory}
                                                    clearTypeahead={clearCategoryTypeahead}
                                                    clearTypeaheadCallback={clearCategoryTypeaheadFn}
                                                    scrollableList={true}
                                                    maxResults={100}
                                                />

                                                {/* Select All Products in Category Option */}
                                                <div className={"mt-3"}>
                                                    <div className={"form-check"}>
                                                        <input
                                                            className={"form-check-input"}
                                                            type={"checkbox"}
                                                            id={"select-all-products"}
                                                            checked={selectAllProductsInCategory}
                                                            onChange={(e) => setSelectAllProductsInCategory(e.target.checked)}
                                                            disabled={!selectedCategory}
                                                        />
                                                        <label className={"form-check-label"} htmlFor={"select-all-products"}>
                                                            Select all products in this category
                                                        </label>
                                                    </div>
                                                    {selectedCategory && selectAllProductsInCategory && (
                                                        <div className={"text-info small mt-1"}>
                                                            All products in &ldquo;{selectedCategory.name}&rdquo; will be included in the
                                                            report
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : null}

                                {/* Other reports - Original UI */}
                                {currentReport !== ReportTypeEnum.PRODUCT_CUSTOMER_SALES && selectedCatalog && !hideCatalogItemSelection ? (
                                    <div className={"mt-3"}>
                                        <div>
                                            <OwLabel title={"catalog_item"} isBold={true} isUnderline={true} showIsReqAsterik={true} />
                                        </div>
                                        <TypeaheadFn
                                            lookupFn={doCatalogItemLookup}
                                            availableOptions={foundCatalogItems || []}
                                            titleProp={"name"}
                                            selectedOptionFn={selectCatalogItem}
                                            selectedOption={selectedCatalogItem}
                                            resetTypeahead={clearTypeahead}
                                            resetTypeaheadCallbackFn={clearTypeaheadFn}
                                            isScrollable={true}
                                        />
                                    </div>
                                ) : null}
                                {currentReport !== ReportTypeEnum.PRODUCT_CUSTOMER_SALES && selectedCatalog && showCatalogSelection ? (
                                    <div className={"mt-3"}>
                                        <div>
                                            <OwLabel title={"category"} isBold={true} isUnderline={true} showIsReqAsterik={false} />
                                        </div>
                                        <Typeahead
                                            isSelectableFn={() => true}
                                            typeaheadApiFn={doCategoryLookup}
                                            typeaheadItems={foundCategories}
                                            titleProp={"name"}
                                            selectedItemTitleProp={"name"}
                                            selectedItemFn={selectCategory}
                                            selectedItem={selectedCategory}
                                            clearTypeahead={clearCategoryTypeahead}
                                            clearTypeaheadCallback={clearCategoryTypeaheadFn}
                                            scrollableList={true}
                                            maxResults={100}
                                        />
                                    </div>
                                ) : null}
                            </div>

                            {currentReport === ReportTypeEnum.SINGLE_CATEGORY_QTY_SALES_REPORT ? (
                                <div>
                                    <OwCheckbox
                                        name={"includeSubCategories"}
                                        label={"include_subcategories"}
                                        fn={handleChange}
                                        truthyVal={true}
                                        falsyVal={false}
                                        checked={includeSubCategories}
                                    />
                                </div>
                            ) : null}
                        </div>
                    ) : null}

                    {supplierModel.has_quotes && currentReport === ReportTypeEnum.ITEM_IN_ORDERS_REPORT ? (
                        <div className={"mb-3 col-12"}>
                            <div className={"col-12"}>
                                <OwLabel />
                            </div>
                            <div className={"col-12"}>
                                <OwToggle
                                    fn={handleChange}
                                    name={"quotesOnly"}
                                    label={"quotes_only"}
                                    active={quotesOnly}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>
                    ) : null}

                    {showOrderStatusSelection && !quotesOnly ? (
                        <div className={"d-flex flex-column mt-3"}>
                            {supplierOrderSteps
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((step) => {
                                    return (
                                        <div key={step.order_state_id} className={"col-auto"}>
                                            <OwToggle
                                                name={step.name}
                                                label={step.name}
                                                fn={() => {
                                                    toggleStep(step);
                                                }}
                                                active={stepSelected[Number(step.order_state_id)]}
                                                labelOnRight={true}
                                            />
                                        </div>
                                    );
                                })}
                        </div>
                    ) : null}

                    {showPricingSelection && (
                        <div className={"mt-5 mb-2"}>
                            <div className={"col-12"}>
                                <OwToggle
                                    fn={handleChange}
                                    name={"includePricing"}
                                    label={"include_pricing"}
                                    active={includePricing}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>
                    )}

                    {showQboOptions && supplierModel.Supplier_Integration?.has_qbo ? (
                        <OrdersDetailReportQbo onChange={(quickbooksOnline) => setQuickbooksOnline(quickbooksOnline)} />
                    ) : null}
                </div>
            </div>

            <div className={""}>
                <div className={"col-12 mb-1"}>
                    <OwLabel />
                </div>
                <div>
                    <OwButton title={"create"} fn={createReport} active={active} disableOnActive={true} disabled={!reqOptionsSet} />
                </div>
            </div>
        </div>
    );
};
